import React from 'react'
import { Section, GuideHeader, P, UI, Bullets, Callout } from './GuideParts'

export default function LearningGuide() {
  return (
    <div className="space-y-8">
      <GuideHeader
        title="Learning"
        intro="Short how-to videos, grouped by topic, available to everyone."
      />

      <Section number={1} title="Watching a Video">
        <Bullets>
          <li>Open <UI>Learning</UI> in the sidebar. Videos are grouped into categories.</li>
          <li>Choose a video to play it on its own page. The address of that page can be shared with colleagues.</li>
          <li>Videos are published centrally, so a new one shows up for everyone after a page refresh.</li>
        </Bullets>
        <Callout kind="info">
          If you see “Learning content is unavailable right now”, the video library could not be reached. Try again later.
        </Callout>
      </Section>

      <Section number={2} title="Managing Learning Content">
        <P>
          Only Admins of the organisation that hosts the library see a <UI>Manage</UI> button. There they can add categories and
          guides, upload a video (mp4, webm or mov, up to 250 MB), reorder items and archive or restore a guide. A guide only
          appears for viewers once it has a video and is not archived.
        </P>
      </Section>
    </div>
  )
}
